






import React, { useState } from "react";
import "../../styles/Enquiry.css";
import enquiryImage from "../../images/enquiry-slider.jpg"; // Import the image

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Enquiry submitted successfully!");
  };

  return (
    <div className="enquiry-container">
      {/* Image Slider */}
      <div className="image-slider">
        <img src={enquiryImage} alt="Enquiry Slider" />
      </div>

      {/* Enquiry Form Section */}
      <div className="enquiry-form-card">
        <h2>Enquire Now</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          <input type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
          <textarea name="comments" placeholder="Your Comments" value={formData.comments} onChange={handleChange} required></textarea>
          <button type="submit" className="send-btn">Send</button>
        </form>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <a href="/privacy-statement" className="footer-link">Privacy Statement</a> |
              <a href="/terms-of-use" className="footer-link"> Terms Of Use</a>
            </p>
          </div>
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd., </p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Enquiry;

